module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 64
// module chunks = 25